<template>
  <mds-layout-grid>
    <filter-section @reset-pagination="resetPagination" />
    <header-section />
    <main-section-pr-ec />
    <pagination-section 
      v-if="dataLoaded && isEquityTenant"
      :dataLength="dataLength"
      @page-changed="handlePageChange"
      ref="paginationSection"
    />
  </mds-layout-grid>
</template>

<script>
import FilterSection from '@/components/collection-pr-ec/filter/FilterSection.vue';
import HeaderSection from '@/components/collection-pr-ec/header/HeaderSection.vue';
import MainSectionPrEc from '@/components/collection-pr-ec/MainSectionPrEc.vue';
import PaginationSection from '@/components/collection-pr-ec/pagination/PaginationSection.vue';
import { mapState } from 'vuex';
import { MODULE, COMMON } from '@/constants/store.constant';
export default {
  name: 'CollectionPrEcPage',
  components: {
    FilterSection,
    HeaderSection,
    MainSectionPrEc,
    PaginationSection,
  },
  computed: {
    ...mapState({
      dataLoaded: state => state.COLLECTION_PR_EC_MODULE.dataLoaded,
      dataLength: state => state.COLLECTION_PR_EC_MODULE.jobs.length || 0,
     
    }),
    isEquityTenant() {
      const tenant = this.$store.getters[`${MODULE.AUTH}/${COMMON.GET_STATE}`]('currentTenant');
      return tenant === 'EQUITY';
    },
  },
  methods: {
    handlePageChange(page) {
      this.$store.commit(`${MODULE.COLLECTION_PR_EC_MODULE}/${COMMON.UPDATE_PARAM}`, { name: 'pageNumber', value: page.page });
      this.$store.commit(`${MODULE.COLLECTION_PR_EC_MODULE}/${COMMON.UPDATE_PARAM}`, { name: 'searchParam', value: this.$store.getters[`${MODULE.COLLECTION_PR_EC_MODULE}/${COMMON.GET_STATE_BY_NAME}`]('filterText') ?? '' });
      this.$store.commit(`${MODULE.COLLECTION_PR_EC_MODULE}/${COMMON.UPDATE_STATE}`, { name: 'shouldRefresh', value: true });
    },
    resetPagination() {
      if(this.isEquityTenant) {
        this.$refs.paginationSection.resetPage();
      }
    },
  },
  watch: {
    dataLength(newVal) {
      if (newVal < 100) {
        this.$store.commit(`${MODULE.COLLECTION_PR_EC_MODULE}/${COMMON.UPDATE_PARAM}`, { name: 'pageNumber', value: 1 });
      }
    }
  },
  created() {
    // Reset pagination to first page on refresh
    this.$store.commit(`${MODULE.COLLECTION_PR_EC_MODULE}/${COMMON.UPDATE_PARAM}`, { name: 'pageNumber', value: 1 });
  }
};
</script>

